import axios from 'axios';

// Create axios instance
const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Important untuk cookies session
});

// Response interceptor untuk handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Redirect to login if unauthorized
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// ========== AUTH API ==========
export const authAPI = {
  login: (username, password) => 
    api.post('/login', { username, password }),
  
  logout: () => 
    api.post('/logout'),
  
  checkStatus: () => 
    api.get('/status'),
};

// ========== CERTIFICATES API ==========
export const certificatesAPI = {
  getAll: () => 
    api.get('/certificates'),
  
  download: (certId) => 
    api.get(`/certificates/${certId}/download`, {
      responseType: 'blob'
    }),
  
  renewDryRun: (certId) => 
    api.post(`/certificates/${certId}/renew`),
  
  renewLive: (certId) => 
    api.post(`/certificates/${certId}/renew-live`),
};

// ========== LOGS API ==========
export const logsAPI = {
  getLogs: (params) => 
    api.get('/logs', { params }),
  
  deleteLogs: (startDate, endDate) => 
    api.delete('/logs', {
      params: { start_date: startDate, end_date: endDate }
    }),
};

// ========== SETTINGS API ==========
export const settingsAPI = {
  testTelegram: () => 
    api.post('/test-telegram'),
};

export default api;
